module.exports = __webpack_public_path__ + "img/50A.16f2e03c.png";